export const cssStyles = ({ cssStyles: styles }) => styles || '';
